import { AxiosResponse } from "axios";
import { PaginationResponse } from "@/main/models/common/paginationResponse";
import {
	ExportorderscreenreportRequest,
	ExportSupplierPerformanceRequest,
	ProcurementReportRequest,
	SearchGridShippingAndBillingRequest,
	SearchGridSupplierPerformanceRequest,
} from "@/main/models/request";
import {
	DynamicReport_VariableResponse,
	DynamicReportHistoricalDetailsResponse,
	DynamicReportHistoricalResponse,
	DynamicReportResponse,
	DynamicReportUserGroupResponse,
	ProcurementReportResponse,
	SearchGridShippingCostResponse,
	SupplierPerformanceReportResponse,
} from "@/main/models/response";
import { Result } from "@/main/models/common/resultResponse";
import {
	DynamicReportQueryRequest,
	DynamicReportRequest,
	DynamicReportUserGroupRequest,
} from "@/main/models/request/dynamicReportRequest";
import { DynamicReportHistoryGridRequest } from "@/main/models/request/dynamicReportGridRequest";

export abstract class IProcurementReportApi {
	abstract searchgrid(
		request: ProcurementReportRequest,
	): Promise<AxiosResponse<PaginationResponse<ProcurementReportResponse>>>;

	abstract exportOrder(request: ProcurementReportRequest): Promise<AxiosResponse<Result<string>>>;

	abstract searchGridShippingCost(
		request: SearchGridShippingAndBillingRequest,
	): Promise<AxiosResponse<PaginationResponse<SearchGridShippingCostResponse>>>;

	abstract shippingCostReportExport(request: ProcurementReportRequest): Promise<AxiosResponse<Result<string>>>;

	abstract searchGridSupplierPerformance(
		request: SearchGridSupplierPerformanceRequest,
	): Promise<AxiosResponse<PaginationResponse<SupplierPerformanceReportResponse>>>;

	abstract exportSupplierPerformance(request: ExportSupplierPerformanceRequest): Promise<AxiosResponse<Result<string>>>;
	abstract exportOrderScreenReport(request: ExportorderscreenreportRequest): Promise<AxiosResponse<Result<string>>>;
	abstract saveDynamicReport(request: DynamicReportRequest): Promise<AxiosResponse<Result<string>>>;
	abstract getDynamicReportDetails(guidDynamicReport: string): Promise<AxiosResponse<Result<DynamicReportResponse>>>;
	abstract getDynamicReportUserGroups(
		request: DynamicReportUserGroupRequest,
	): Promise<AxiosResponse<Result<DynamicReportUserGroupResponse[]>>>;
	abstract GetDynamicReportHistoryGrid(
		request: DynamicReportHistoryGridRequest,
	): Promise<AxiosResponse<PaginationResponse<DynamicReportHistoricalResponse>>>;
	abstract getDynamicReportHistDetails(
		guidDynamicReportHistorical: string,
	): Promise<AxiosResponse<Result<DynamicReportHistoricalDetailsResponse[]>>>;
	abstract getDynamicReportFilters(
		guidDynamicReport: string,
	): Promise<AxiosResponse<Result<DynamicReport_VariableResponse[]>>>;
	abstract exportDynamicReport(
		request: DynamicReportQueryRequest,
		timeout: number,
	): Promise<AxiosResponse<Result<boolean>>>;
}
